import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";
import SuspendedPageViewTracker from "@/components/Analytics/PageViewTracker";
import { useConsentStore } from "./ConsentStore";
import RequestTrackingPopup from "@/components/Analytics/RequestTrackingPopup";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const consentAcquired = useConsentStore((state) => state.consentToAnalytics);

  useEffect(() => {
    posthog.init("phc_ChFmN8jyvNnzwiEzD6aPBQA0mSVreiQ5kZmZwmTTrUC", {
      api_host: "https://us.i.posthog.com",
      opt_out_capturing_by_default: true,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true,
      autocapture: true,
      session_recording: {
        maskAllInputs: true,
      },
    });
  }, []);

  useEffect(() => {
    if (consentAcquired) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }
  }, [consentAcquired]);

  return (
    <PHProvider client={posthog}>
      <SuspendedPageViewTracker />
      {children}
      <RequestTrackingPopup />
    </PHProvider>
  );
}
